module.exports = __webpack_public_path__ + "img/asset.ddf57875.png";